var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8538 11.3866C3.70196 10.4149 3.59882 9.74911 3.56317 9.23226C3.52817 8.72495 3.56827 8.46691 3.63529 8.29032C3.80024 7.85574 4.1114 7.49217 4.51532 7.26212C4.67944 7.16864 4.9282 7.08918 5.43483 7.04544C5.95099 7.00087 6.62467 7 7.60824 7H16.3918C17.3753 7 18.049 7.00087 18.5652 7.04544C19.0718 7.08918 19.3206 7.16864 19.4847 7.26212C19.8886 7.49217 20.1998 7.85574 20.3647 8.29032C20.4317 8.46691 20.4718 8.72495 20.4368 9.23226C20.4012 9.74911 20.298 10.4149 20.1462 11.3866L19.3576 16.4336C19.2052 17.4091 19.0988 18.0857 18.9754 18.6106C18.8549 19.1233 18.7334 19.4187 18.5863 19.6434C18.274 20.1204 17.8322 20.4985 17.3127 20.7334C17.068 20.8441 16.7574 20.9185 16.2322 20.9585C15.6945 20.9993 15.0097 21 14.0223 21H9.97765C8.99032 21 8.30545 20.9993 7.76778 20.9585C7.24262 20.9185 6.93203 20.8441 6.68728 20.7334C6.16781 20.4985 5.72603 20.1204 5.41371 19.6434C5.26657 19.4187 5.14511 19.1233 5.02459 18.6106C4.9012 18.0857 4.79481 17.4091 4.64239 16.4336L3.8538 11.3866Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73804 5.47937C9.02517 4.44568 9.12074 4.14233 9.26431 3.91889C9.51901 3.52248 9.90548 3.22873 10.3556 3.08942C10.6093 3.01089 10.9272 3 12 3C13.0728 3 13.3907 3.01089 13.6444 3.08942C14.0945 3.22873 14.481 3.52248 14.7357 3.91889L15.4758 3.44335L14.7357 3.91889C14.8793 4.14233 14.9748 4.44568 15.262 5.47937L15.6844 7H8.31564L8.73804 5.47937Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H8.1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10H16.1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8cde6cb479dc68a2a1d97b1ffab1f566.svg";
export { ForwardRef as ReactComponent };